<template>
	<section class="other_page_banner sale_banner banner_nxt_sec_touch">
		<div class="container">
			<div class="row">
				<div class="col-sm-7 order-2 order-md-1">
					<div class="ban_lt">
						<h5>
							{{ $t('new_ui.personal_sale_page.section_banner.title.one') }}
						</h5>
						<h2>
							{{
								$t('new_ui.personal_sale_page.section_banner.main_title.one')
							}}
						</h2>
						<p>
							{{ $t('new_ui.personal_sale_page.section_banner.paragraph.one') }}
						</p>

						<div
							class="ban_lt_btn d-flex justify-content-start align-items-center p-top"
						></div>
					</div>
				</div>
				<div class="col-sm-5 order-1 order-md-2">
					<div class="ban_rt">
						<img :src="img.image1" alt="Logo" />
					</div>
				</div>
			</div>
		</div>
	</section>
	<section class="credit_system wallet_sec">
		<div class="container">
			<div class="row">
				<div class="col-sm-12 border_dash">
					<div class="row">
						<div class="col-sm-6">
							<div class="creditcard_system_inn credit_system_rt">
								<img class="mb-0" :src="img.image2" alt="" />
							</div>
						</div>
						<div class="col-sm-6">
							<div class="creditcard_system_inn">
								<span>{{
									$t('new_ui.personal_sale_page.credit_system.title')
								}}</span>
								<div class="creditcard_system_txt">
									<h4>
										{{
											$t(
												'new_ui.personal_sale_page.credit_system.main_title.one',
											)
										}}
										<br />{{
											$t(
												'new_ui.personal_sale_page.credit_system.main_title.two',
											)
										}}<br />
										{{
											$t(
												'new_ui.personal_sale_page.credit_system.main_title.three',
											)
										}}
										<span>{{
											$t(
												'new_ui.personal_sale_page.credit_system.main_title.four',
											)
										}}</span>
									</h4>
									<p>
										{{
											$t(
												'new_ui.personal_sale_page.credit_system.paragraph.one',
											)
										}}
									</p>
									<p>
										{{
											$t(
												'new_ui.personal_sale_page.credit_system.paragraph.two',
											)
										}}
									</p>
									<div class="starting_to_btn">
										<a href="/auth/register">{{
											$t(
												'new_ui.personal_sale_page.credit_system.cta_buttons.one',
											)
										}}</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
	<section class="charging_sec sale_btm">
		<div class="container">
			<div class="row">
				<div class="col-sm-7 order-2 order-md-1">
					<div class="charging_lt sale_chrg">
						<span>{{
							$t('new_ui.personal_sale_page.charging_sec.title')
						}}</span>
						<div class="charging_lt_txt">
							<h4>
								{{ $t('new_ui.personal_sale_page.charging_sec.sub_title.one') }}
								<span>{{
									$t('new_ui.personal_sale_page.charging_sec.sub_title.two')
								}}</span>
								{{
									$t('new_ui.personal_sale_page.charging_sec.sub_title.three')
								}}
							</h4>
							<p>
								{{ $t('new_ui.personal_sale_page.charging_sec.paragraph.one') }}
							</p>
							<p>
								{{ $t('new_ui.personal_sale_page.charging_sec.paragraph.two') }}
							</p>
							<div class="starting_to_btn">
								<a href="/auth/register">{{
									$t('new_ui.personal_sale_page.charging_sec.cta_buttons.one')
								}}</a>
							</div>
						</div>
					</div>
				</div>
				<div class="col-sm-5 order-1 order-md-2">
					<div class="charging_rt">
						<img :src="img.image3" alt="" />
					</div>
				</div>
			</div>
		</div>
	</section>
	<section class="newsletter_sec">
		<div class="container">
			<div class="row">
				<div class="col-sm-12 col-xxl-5 col-xl-5 col-lg-5 col-md-12">
					<div class="newsletter_lt">
						<span>{{
							$t('new_ui.personal_sale_page.section_newsletter.label')
						}}</span>
						<div class="newsletter_txt">
							<h4>
								<span>{{
									$t('new_ui.personal_sale_page.section_newsletter.title.one')
								}}</span>
								{{
									$t('new_ui.personal_sale_page.section_newsletter.title.two')
								}}
							</h4>
						</div>
					</div>
				</div>
				<div class="col-sm-12 col-xxl-7 col-xl-7 col-lg-7 col-md-12">
					<div class="newsletter_rt">
						<p>
							{{
								$t(
									'new_ui.personal_sale_page.section_newsletter.description.one',
								)
							}}
						</p>
						<form>
							<div class="news_mail">
								<div class="news_mail_lt">
									<input
										type="email"
										:placeholder="
											$t(
												'new_ui.personal_sale_page.section_newsletter.form.placeholder',
											)
										"
									/>
								</div>
								<div class="news_mail_rt">
									<button type="submit" value="submit">
										{{
											$t(
												'new_ui.personal_sale_page.section_newsletter.form.button',
											)
										}}
									</button>
								</div>
							</div>
						</form>
						<p class="mt-3">
							{{
								$t(
									'new_ui.personal_sale_page.section_newsletter.description.two',
								)
							}}
						</p>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import saleban from '@/assets/images/sub/saleban.png';
import sale1 from '@/assets/images/sub/sale1.png';
import salerate from '@/assets/images/sub/salerate.png';

export default {
	data: () => {
		return {
			img: {
				image1: saleban,
				image2: sale1,
				image3: salerate,
			},
		};
	},
};
</script>
